import queryString from 'query-string'
import Dajax from '@didi/dajax'

const isEnv = ['test', 'development'].indexOf(process.env.NODE_ENV) >= 0
const { env } = queryString.parse(window.location.search)
const { preview } = queryString.parse(window.location.search)
let dataApi = '//es-static.xiaojukeji.com/static/web/'

if (env === 'dev') {
    dataApi = 'http://100.69.238.155:8002/static/ndpubimg/'
}

if (preview === 'true') {
    dataApi = 'http://100.69.238.155:8002/static/ndpubimg/'
}

if (isEnv) {
    dataApi = 'https://gift-yspre-inter.didistatic.com/static/anything/'
}

async function getData () {
    // let data = {}
    let { s } = queryString.parse(window.location.search)
    console.log(s, s.length)
    if (Array.isArray(s)) {
        s = s[0]
    }
    console.log(s)
    if (s) {
        console.log('数据来源于接口请求')
        // try {
        return fetch(`//eos-marketing.es.xiaojukeji.com/api/v2/rule/cache/timestamp?pageKey=${s}`).then(function (response) {
            return response.json()
        }).then(async function (data) {
            if (data && data.data) {
                try {
                    const res = await Dajax.get(`${dataApi}${s}.json?t=${data.data}`)
                    return res.data
                } catch (error) {
                    throw error
                }
            } else {
                try {
                    const res = await Dajax.get(`${dataApi}${s}.json?t=1.0.0`)
                    return res.data
                } catch (error) {
                    throw error
                }
            }
        }).catch(async function (e) {
            try {
                const res = await Dajax.get(`${dataApi}${s}.json?t=1.0.0`)
                return res.data
            } catch (error) {
                throw error
            }
        })
        // } catch (err) {
        //     throw err
        // }
    } else if (isEnv) {
        console.log('数据来源于mockData')
        return import('mockData')
        // try {
        //     // eslint-disable-next-line global-require
        //     return import('mockData')
        // } catch (err) {
        //     throw err
        // }
    } else {
        throw new Error(`can not fetch data in ${process.env.NODE_ENV}, please check your url, it mast have s in query`)
    }
    // return data
}

export default getData
